import { HomeIcon } from '@heroicons/react/solid'
import type { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'
import ListItem from '../ListItem'
import { Paragraph } from '../Typography'
import { ErrorTemplate } from './Template'
import CustomButton from '../Shared/UIComponents/Button'

type Props = {
  missingValues: Record<string, boolean>
  extraMessage?: string
  children?: ReactElement
}

export function ErrorMissingData(props: Props) {
  const navigate = useNavigate()

  return (
    <ErrorTemplate
      title="Missing data"
      message="We can't continue as you're missing some data"
      extraMessage={
        <>
          <ul className="contents">
            {Object.entries(props.missingValues).map(([key, value]) =>
              value ? <ListItem key={key} label={key} /> : null,
            )}
          </ul>

          {props.extraMessage && (
            <Paragraph className="col-span-full">
              {props.extraMessage}
            </Paragraph>
          )}
        </>
      }
      extraButton={props.children}
      button={
        <CustomButton
          label="go home"
          onClick={() => navigate('/')}
          icon={<HomeIcon />}
          iconPosition="left"
        />
      }
    />
  )
}
